import { apiClient } from "@/api/client";
import { API_ENDPOINTS } from "@/api/endpoints";

export interface ApiFootballAuditIssue {
  matchId: number;
  label: string;
  score: string;
  missedGoals: number;
  missedAssists: number;
  missedCards: number;
  unmappedApiPlayerIds: number[];
}

export interface ApiFootballAuditResponse {
  totalCompletedMatches: number;
  affectedMatches: number;
  issues: ApiFootballAuditIssue[];
  ranAt: string;
}

export interface ApiFootballIngestSummary {
  matchId: number;
  apiFixtureId: number;
  previousStatus: string;
  newStatus: string;
  eventsInserted: number;
  eventsSkippedUnmappedPlayer: number;
  homeScore: number;
  awayScore: number;
}

/**
 * Admin tools backed by the live event ingestion service in
 * src/api-football. The audit endpoint walks every completed match and
 * reports gaps between api-football's event timeline and our DB; the
 * ingest endpoint re-runs the ingest path for a single match (idempotent
 * via the MatchEvent unique constraint, so safe to click multiple times).
 */
export const apiFootballService = {
  audit: (): Promise<ApiFootballAuditResponse> =>
    apiClient.get(API_ENDPOINTS.API_FOOTBALL.AUDIT),

  ingestMatch: (matchId: number): Promise<ApiFootballIngestSummary> =>
    apiClient.post(API_ENDPOINTS.API_FOOTBALL.INGEST(matchId)),

  /**
   * Fire the same tick the @Cron decorator runs every 5 min — but right
   * now. Returns immediately; the actual work happens server-side and
   * is visible in Railway logs as `[ApiFootballScheduler] tick start`.
   */
  tickNow: (): Promise<{ ok: boolean; note: string }> =>
    apiClient.post(API_ENDPOINTS.API_FOOTBALL.TICK_NOW),
};
